module.exports = __webpack_public_path__ + "/img/myob-icon.a55c99b872.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/myob-icon.svg
// module id = 1392
// module chunks = 0